{
  "fr": {
    "datatable": {
      "actions": {
        "bulk_action": "Action en masse",
        "bulk_edit": "Modification en masse",
        "clear_filters": "Effacer les filtres",
        "collapse_all": "Tout réduire",
        "deselect_all": "Tout désélectionner",
        "expand_all": "Tout développer",
        "select_all": "Tout sélectionner"
      },
      "import": {
        "title": "Importer",
        "success": "Fichier importé avec succès",
        "errors_title": "Échec de l'import",
        "errors_description": "L'import a été annulé car {count} ligne(s) contenaient des erreurs. Aucun enregistrement n'a été importé.",
        "error_row": "Ligne {row}"
      },
      "labels": {
        "freeze_columns": "Figer les colonnes",
        "freeze_rows": "Figer les lignes",
        "gridlines": "Quadrillage",
        "size": "Taille",
        "sticky_headers": "En-têtes fixes",
        "striped_rows": "Lignes zébrées",
        "toggle_columns": "Basculer les colonnes",
        "group_by": "Regrouper par"
      }
    }
  }
}
